import { errorValidation } from './utils';

(() => {
    const $form = $("form[name='register']");
    $form.validate({
        ignore: [],
        ...errorValidation,
        errorClass: 'form__error',
        rules: {
            'register[email]': {
                required: true,
                email: true,
            },
            'register[password]': {
                required: true,
            },
            'register[repeat_password]': {
                required: true,
                equalTo: "#password"
            }
        },
        messages: {
            'register[email]': {
                required: window.translations.required,
                email: window.translations.emailInvalid,
            },
            'register[password]': {
                required: window.translations.required,
            },
            'register[repeat_password]': {
                required: window.translations.required,
                equalTo: window.translations.equalTo,
            }
        },
        submitHandler: (form) => {
            form.submit();
        },
        success: function (label) {
            let name = label.attr('for');
            label.text('');
        },
    });
})();
